import { ShopifyAppNames } from "@redotech/redo-order-common/sales-channels";
import {
  CloudXCancelASNOn,
  CloudXUPCType,
} from "@redotech/redo-return-core-common/integrations/returns/cloudx/types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const cloudxSettings = defineIntegrationSettings({
  fields: {
    warehouseAsPlainString: z
      .string()
      .trim()
      .min(1, "Warehouse name is required"),
    warehouseTimezone: z.string().nullable(),
    testMode: z.boolean(),
    autoProcessReturns: z.boolean(),
    createReturns: z.boolean(),
    upcType: z.enum(CloudXUPCType),
    excludedAppNames: z.array(createEnum(ShopifyAppNames)),
    cancelASNOn: z.enum(CloudXCancelASNOn),
  },
  secrets: {
    clientSecret: z.string().trim().min(1, "Client secret is required"),
  },
  connectOnly: {},
  computed: {},
});
